import {React} from "react";
import './Warranty.scss'

const  Warranty= () => {
    return ( 
        <div className="contentWarranty">
            <div className="warrantyItem">
                <div className="securePayment"></div>
                <label>پرداخت امن</label>
                <span className="spanAllCards">با تمامی کارت های عضو شتاب</span>
            </div>
            <div className="warrantyItem">
                <div className="onlineSupport"></div>
                <label>پشتیبانی آنلاین</label>
                <span>پشتیبانی فنی ۷/۲۴</span>
            </div>
            <div className="warrantyItem">
                <div className="financialWarrenty"></div>
                <label>گارانتی مالی</label>
                <span>تضمین کیفیت و اصالت</span>
            </div>
            <div className="warrantyItem">
                <div className="countrySupport"></div>
                <label>خدمات کشوری</label>
                <span>ارائه خدمات به سراسر کشور</span>
            </div>
        </div>
     );
}

export default Warranty;
